function init() {
  const dateInputs = document.querySelectorAll('input[type="date"]');

  if (dateInputs) {
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    dateInputs.forEach(input => {
      const wrapperDiv = document.createElement('div');
      wrapperDiv.appendChild(input.cloneNode(true));
      input.parentNode.replaceChild(wrapperDiv, input);

      wrapperDiv.classList.add('kirinus-date-icon');

      if (isMobileDevice()) {
        wrapperDiv.classList.add('kirinus-hide-default-date-value');

        if (wrapperDiv.querySelector('input').hasAttribute('placeholder')) {
          wrapperDiv.style.setProperty('--date-placeholder', `"${wrapperDiv.querySelector('input').getAttribute('placeholder')}"`);
        }
      }

      wrapperDiv.querySelector('input').addEventListener('input', function () {
        if (this.value.length > 0) {
          this.classList.add('is-filled-out');
          if (isMobileDevice()) {
            wrapperDiv.classList.remove('kirinus-hide-default-date-value');
          }
        } else {
          this.classList.remove('is-filled-out');
          if (isMobileDevice()) {
            wrapperDiv.classList.add('kirinus-hide-default-date-value');
          }
        }
      });
    });
  }
}

export default {
  init,
};
